var map = {
	"./al.json": 85650,
	"./ar.json": 82694,
	"./az.json": 44320,
	"./bg.json": 55312,
	"./chi.json": 20091,
	"./cs.json": 80539,
	"./de.json": 89957,
	"./en.json": 16874,
	"./es-co.json": 79599,
	"./es.json": 9330,
	"./et.json": 59892,
	"./fa.json": 81471,
	"./fr.json": 65009,
	"./hr.json": 77,
	"./hu.json": 32024,
	"./it.json": 25230,
	"./ja.json": 78806,
	"./lt.json": 58461,
	"./lv.json": 25907,
	"./mk.json": 48271,
	"./ms.json": 93033,
	"./nl.json": 466,
	"./pl.json": 16290,
	"./ru.json": 428,
	"./sk.json": 64567,
	"./sq.json": 85184,
	"./sr.json": 39184,
	"./th.json": 85188,
	"./ti.json": 55730,
	"./tr.json": 74271,
	"./uk.json": 35085,
	"./ur.json": 87505,
	"./vi.json": 22918,
	"./zh.json": 44418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91234;